var map = {
	"./background/bg.png": 3841,
	"./floor.jpg": 4894,
	"./loader.glb": 2621,
	"./men/animations/package.glb": 2727,
	"./men/animations/thumb/clap.png": 6365,
	"./men/animations/thumb/dance.png": 4525,
	"./men/animations/thumb/hi.png": 616,
	"./men/animations/thumb/hiphop.png": 5105,
	"./men/animations/thumb/idle.png": 3947,
	"./men/animations/thumb/jump.png": 9025,
	"./men/animations/thumb/run.png": 3853,
	"./men/animations/thumb/walk.png": 5307,
	"./men/base.glb": 5062,
	"./men/styles/hair/thumb/type_1.png": 1703,
	"./men/styles/hair/thumb/type_2.png": 3175,
	"./men/styles/hair/thumb/type_3.png": 5304,
	"./men/styles/hair/type_1.glb": 3544,
	"./men/styles/hair/type_2.glb": 6760,
	"./men/styles/hair/type_3.glb": 7990,
	"./men/styles/pant/thumb/type_1.png": 9838,
	"./men/styles/pant/thumb/type_2.png": 4833,
	"./men/styles/pant/thumb/type_3.png": 8705,
	"./men/styles/pant/thumb/type_4.png": 5744,
	"./men/styles/pant/thumb/type_5.png": 1289,
	"./men/styles/pant/thumb/type_6.png": 4549,
	"./men/styles/pant/type_1.glb": 2534,
	"./men/styles/pant/type_2.glb": 2843,
	"./men/styles/pant/type_3.glb": 2729,
	"./men/styles/pant/type_4.glb": 4854,
	"./men/styles/pant/type_5.glb": 4623,
	"./men/styles/pant/type_6.glb": 9684,
	"./men/styles/shirt/thumb/type_1.png": 3371,
	"./men/styles/shirt/thumb/type_10.png": 5907,
	"./men/styles/shirt/thumb/type_2.png": 5776,
	"./men/styles/shirt/thumb/type_3.png": 174,
	"./men/styles/shirt/thumb/type_4.png": 3850,
	"./men/styles/shirt/thumb/type_5.png": 4334,
	"./men/styles/shirt/thumb/type_6.png": 2100,
	"./men/styles/shirt/thumb/type_7.png": 5734,
	"./men/styles/shirt/thumb/type_8.png": 4829,
	"./men/styles/shirt/thumb/type_9.png": 2519,
	"./men/styles/shirt/type_1.glb": 2444,
	"./men/styles/shirt/type_10.glb": 101,
	"./men/styles/shirt/type_2.glb": 3260,
	"./men/styles/shirt/type_3.glb": 1913,
	"./men/styles/shirt/type_4.glb": 2950,
	"./men/styles/shirt/type_5.glb": 3737,
	"./men/styles/shirt/type_6.glb": 4512,
	"./men/styles/shirt/type_7.glb": 1231,
	"./men/styles/shirt/type_8.glb": 2391,
	"./men/styles/shirt/type_9.glb": 9008,
	"./men/styles/shoe/thumb/type_1.png": 6660,
	"./men/styles/shoe/thumb/type_2.png": 2439,
	"./men/styles/shoe/type_1.glb": 7894,
	"./men/styles/shoe/type_2.glb": 4369,
	"./stage.glb": 2103,
	"./stage_glow.glb": 3770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3026;